import { Box, Grid, lighten, Theme, useTheme } from "@mui/material";
import { Divider } from "../Divider/Divider";
import { AnimatedCardProps } from "./AnimatedCard";
import React from "react";

export function MobileAnimatedCard(props: AnimatedCardProps) {
  const ref = React.useRef<HTMLElement>(null);
  const theme = useTheme();
  const styles = useStyles(theme, props);

  React.useEffect(() => {
    const element = ref.current;
    if (element) props?.onRender?.(element);
  }, []);

  return (
    <Box
      className={"animated-card-wrapper"}
      id={props?.domId}
      ref={ref}
      onClick={props?.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      sx={styles.wrapper}
    >
      {props?.renderBody()}

      {!props?.isFooterHidden ? (
        <>
          <Divider />
          <Grid container>{props.renderFooter()}</Grid>
        </>
      ) : null}
    </Box>
  );
}

function useStyles(theme: Theme, props: AnimatedCardProps) {
  return {
    wrapper: {
      opacity: props?.isDisabled ? 0.5 : 1,
      pointerEvents: props?.isDisabled ? "none" : "all",
      borderRadius: "10px",
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      cursor: "pointer",
      width: "100%",
      height: "100%",
      outline: props?.isSelected
        ? `2px solid ${theme.palette.primary.main}`
        : `1px solid ${theme.palette.divider}`,
      boxShadow: props?.isSelected ? `0 0 0 2px ${theme.palette.primary.main}` : `none`, // prettier-ignore
      transition: `
          box-shadow 0.2s ease,
          outline 0.2s ease,
          border-radius 0.01s ease
        `,

      "&:hover": {
        boxShadow: `0 0 0 6px ${lighten(theme.palette.primary.main, 0.8)}`,
      },

      ...props?.style?.wrapper,
      ...props?.style,
    },
  };
}
